/**
 * PoppinPay API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import PreviewOrderResultModel from './PreviewOrderResultModel';

/**
* The OrderPreviewResultModel model module.
* @module model/OrderPreviewResultModel
* @version 1.0.0
*/
export default class OrderPreviewResultModel {
    /**
    * Constructs a new <code>OrderPreviewResultModel</code>.
    * @alias module:model/OrderPreviewResultModel
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>OrderPreviewResultModel</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/OrderPreviewResultModel} obj Optional instance to populate.
    * @return {module:model/OrderPreviewResultModel} The populated <code>OrderPreviewResultModel</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OrderPreviewResultModel();
                        
            
            if (data.hasOwnProperty('IdempotencyKey')) {
                obj['IdempotencyKey'] = ApiClient.convertToType(data['IdempotencyKey'], 'String');
            }
            if (data.hasOwnProperty('Order')) {
                obj['Order'] = PreviewOrderResultModel.constructFromObject(data['Order']);
            }
        }
        return obj;
    }

    /**
    * @member {String} IdempotencyKey
    */
    'IdempotencyKey' = undefined;
    /**
    * @member {module:model/PreviewOrderResultModel} Order
    */
    'Order' = undefined;




}
